let generalModalWindow = document.getElementById("generalModalWindow");
let closeGeneralModal = document.querySelector(".close_modal_general");
let modalGeneralText = document.querySelector(".block_modal_general_text");

let elsForModal = document.querySelectorAll(".for_general_modal");
if (elsForModal.length > 0) {
  for (let element of elsForModal) {
    const blockForModal = element.closest(".block_for_general_modal");
    if (blockForModal.querySelector(".text") !== null) {
      const textForModal = blockForModal.querySelector(".text").innerHTML;
      modalGeneralText.innerHTML = textForModal;
      element.addEventListener("click", function () {
        lockScroll();
        generalModalWindow.style.display = "block";
      });
    }
  }
}

closeGeneralModal &&
  closeGeneralModal.addEventListener("click", function () {
    generalModalWindow.style.display = "none";
    unlockScroll();
  });
document.querySelector(".modal_general_btn_cancel") &&
  document
    .querySelector(".modal_general_btn_cancel")
    .addEventListener("click", function () {
      generalModalWindow.style.display = "none";
      unlockScroll();
    });
window.addEventListener("click", function (event) {
  if (event.target == generalModalWindow) {
    generalModalWindow.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(generalModalWindow);
